<template>
  <div id="contenedor-avance-real-informacion">
    <v-row
      align="center">
      <v-col
        cols="auto">
        <span class="text-subtitle-2">Fecha Cálculo: </span>
      </v-col>
      <date-picker
        v-model="fechaHoy"
        cols="auto">
      </date-picker>
      <v-spacer></v-spacer>
      <v-col>
        <template
          v-if="getUltimaEstimacion()">
          <span class="text-subtitle-2">Última Estimación:</span>
          <v-chip
            class="ml-1 mr-3">
            {{ getUltimaEstimacion().numero }}
          </v-chip>
          {{ getUltimaEstimacion().fechaAl }}
        </template>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        md="3">
        <v-card flat>
          <v-card-title>
            Importe Contrato
          </v-card-title>
          <v-card-text class="text-h5">
            {{ importeContrato | currency }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="6"
        md="3">
        <v-card flat>
          <v-card-title>
            Importe Catálogo
          </v-card-title>
          <v-card-text class="text-h5">
            {{ importeCatalogo | currency }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="6"
        md="3">
        <v-card
          color="verde1"
          flat>
          <v-card-title>
            Importe Estimado
          </v-card-title>
          <v-card-text class="text-h5">
            <v-row
              no-gutters
              justify="space-between">
              <v-col>
                {{ importeEstimado() | currency }}
              </v-col>
              <v-col
                cols="3">
                <v-chip
                  color="green lighten-3">
                  {{ porcentajeEstimado() }}%
                </v-chip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="6"
        md="3">
        <v-card
          color="info"
          dark
          flat>
          <v-card-title>
            Importe Avance Fisico
          </v-card-title>
          <v-card-text class="text-h5">
            <v-row
              no-gutters
              justify="space-between">
              <v-col>
                {{ importeAvanceReal() | currency }}
              </v-col>
              <v-col
                cols="3">
                <v-chip
                  color="blue darken-2"
                  dark>
                  {{ porcentajeAvanceReal() }}%
                </v-chip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import mixContratoAvanceReal from './mixContratoAvanceReal';
import DatePicker from '@/components/inputs/DatePicker.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoAvanceRealInformacion',
  mixins: [mixContratoAvanceReal],
  components: {
    DatePicker,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    catalogo: {
      type: Array,
      required: true,
    },
    estimaciones: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fechaHoy: new Date().toISOString().substr(0, 10),
    };
  },
  methods: {
    getUltimaEstimacion() {
      const numeroEstimaciones = this.estimaciones.map(({ numero }) => numero);
      const numeroUltimaEstimacion = Math.max(...numeroEstimaciones);

      return this.estimaciones.find(({ numero }) => numero === numeroUltimaEstimacion);
    },
    importeEstimado() {
      return this.$ObjSumar(this.estimaciones, 'importeEstimado');
    },
    porcentajeEstimado() {
      return this.$numberRoundDigits(((this.importeEstimado() / this.importeContrato) * 100), 2);
    },
    importeAvanceReal() {
      const importeEstimado = this.$ObjSumar(this.estimaciones, 'importeEstimado');
      const catalogoConAvanceReal = this.catalogo
        .filter(({ ultimoAvanceReal }) => ultimoAvanceReal !== null)
        .map(({ ultimoAvanceReal }) => ({
          importe: ultimoAvanceReal?.importe,
        }));

      const importeAvanceReal = this.$ObjSumar(catalogoConAvanceReal, 'importe');

      return (importeEstimado + importeAvanceReal);
    },
    porcentajeAvanceReal() {
      return this.$numberRoundDigits(((this.importeAvanceReal() / this.importeContrato) * 100), 2);
    },
  },
  computed: {
  },
  watch: {
    fechaHoy: {
      handler(fecha) {
        eventBus.$emit('cambio-fecha-avance-fisico', fecha);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
